'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CloseIcon = require('../../CloseIcon-cf59af30.js');
require('../../tslib.es6-130a177d.js');
require('styled-components');



exports.default = CloseIcon.CloseIcon;
//# sourceMappingURL=index.js.map
